import { theme } from '@client/theme/constants';
import type { ThemeOptions } from '@mui/material';

const AppBar: ThemeOptions['components'] = {
  MuiAutocomplete: {
    styleOverrides: {
      root: {
        padding: '0px !important',

        '& .MuiInput-root': {
          paddingBottom: '0px !important',
        },
      },
      input: {
        '&:not(.MuiOutlinedInput-input)': {
          padding: `${theme.spacing(0, 0, 1 / 2, 0)} !important`,
        },

        '&.MuiOutlinedInput-input': {
          padding: '0px !important',
        },

        '&::-webkit-search-decoration, &::-webkit-search-cancel-button, &::-webkit-search-results-button, &::-webkit-search-results-decoration': {
          display: 'none',
        },
      },
      endAdornment: {
        top: 'unset',
        right: 0,
        position: 'absolute',
      },
    },
  },
};

export default AppBar;
